module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/vback9-99b752992ce035c3f7f469f669a50f79.jpg";